export function setCanonical(url: string) {
	let elem = document.querySelector("link[rel='canonical']");

	if (!elem) {
		elem = document.createElement("link");
		elem.setAttribute("rel", "canonical");
		document.head.append(elem);
	}

	elem.setAttribute("href", url);
}
